import * as React from 'react';

import { TooltipPosition, VisualSize } from '@cian/components';
import { plural } from '@cian/utils/lib/shared/plural';
import { PikButton } from '../../ui/pik_button/pik_button';
import { Region } from '../../utils/regions';
import { Bank } from './bank/bank';
import { connect } from 'react-redux';
import { IApplicationState } from '../../types/redux';
import { IBank } from '../../store/pik_data/banks';

const INITIAL_BANK_COUNT = 6;
const styles = require('./mortgage.css');

interface IMortgageProps {
  banks: IBank[];
  selectedRegion: Region;
}

interface IState {
  showAllBanks: boolean;
}

class MortgageComponent extends React.PureComponent<IMortgageProps, IState> {
  public state = {
    showAllBanks: false,
  };

  public render() {
    const banks = this.getAvailableBanks();
    const moreBanksCount = banks.length - INITIAL_BANK_COUNT;
    const showButton = !this.state.showAllBanks && moreBanksCount > 0;

    if (!banks.length) {
      return null;
    }

    return (
      <div className={styles['mortgage']}>
        <section className={styles['list']}>{this.renderBanks()}</section>

        <div className={styles['button-wrapper']}>
          {showButton && (
            <PikButton onClick={this.showAllBanks} pikTheme="blue" size={VisualSize.MEDIUM}>
              Показать еще {moreBanksCount} {plural(moreBanksCount, ['банк', 'банка', 'банков'])}
            </PikButton>
          )}
        </div>
      </div>
    );
  }

  private showAllBanks = () => this.setState({ showAllBanks: true });

  private getAvailableBanks = () => {
    const { banks, selectedRegion } = this.props;

    return banks.filter(
      bank => !bank.isDisabled && (bank.mortgageByRegion[selectedRegion] || bank.mortgageByRegion['any']),
    );
  };

  private renderBanks = () => {
    let banks = this.getAvailableBanks();
    banks = this.state.showAllBanks ? banks : banks.slice(0, INITIAL_BANK_COUNT);

    return banks.map((bank, index) => {
      const bankMortgageByRegion = bank.mortgageByRegion[this.props.selectedRegion] || bank.mortgageByRegion['any'];

      return (
        <Bank
          tooltipPosition={(index + 1) % 3 === 0 ? TooltipPosition.BOTTOM_RIGHT : TooltipPosition.BOTTOM_LEFT}
          key={bank.id}
          id={bank.id}
          gksList={bank.gksList || []}
          color={bank.color}
          icon={bank.icon}
          iconStyle={bank.iconStyle}
          title={bank.title}
          rate={bankMortgageByRegion.rate}
          initialInstallment={bankMortgageByRegion.initialInstallment}
          minLoanTerm={bankMortgageByRegion.minLoanTerm}
          maxLoanTerm={bankMortgageByRegion.maxLoanTerm}
          militaryMortgage={bankMortgageByRegion.militaryMortgage}
          textColor={bank.textColor}
          selectedRegion={this.props.selectedRegion}
          // commission={bank.commission}
          // citizenship={bank.citizenship}
        />
      );
    });
  };
}

export const Mortgage = connect((state: IApplicationState) => ({
  banks: state.banks || [],
  selectedRegion: state.filter.query.region,
}))(MortgageComponent);
